import script from "./krs.vue?vue&type=script&setup=true&lang=ts"
export * from "./krs.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=4cf449e5&scoped=true&lang=css&external"
import "./krs.vue?vue&type=style&index=1&id=4cf449e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf449e5"]])

export default __exports__